import { render } from "./SimilarSentences.vue?vue&type=template&id=0815c135"
import script from "./SimilarSentences.vue?vue&type=script&lang=js"
export * from "./SimilarSentences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__